// import { AppUtil } from '@/utils/appHooks';
import { matchRoutes } from '@umijs/max';
import 'lib-flexible';
import { requestConfig } from './requestConfig';

export function onRouteChange({ clientRoutes, location }: any) {
  const route = matchRoutes(clientRoutes, location.pathname)?.pop()?.route;
  if (route) {
    // @ts-ignore
    document.title = route?.name || '';
  }
}

export const request = requestConfig;
